import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            telescoopmodellen: null,
            telescoopmodel: null,
        }
    },
    mutations: {
        setTelescoopmodellen(state,modellen){
            state.telescoopmodellen = modellen
        },
        setTelescoopmodel(state,model){
            state.telescoopmodel = model
        }
    },
    actions: {
        async fetchTelescoopmodellen({commit}){
            await axiosInstance.get('/zon/telescoopmodellen')
                .then(result => commit('setTelescoopmodellen', result.data))
        }
    }
}